import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { useDispatch, useSelector } from "react-redux";

import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { v4 } from "uuid";

const StatisticsIndex = () => {
	const auth = useSelector(state => state.auth.user);
	const [teamMembers, setTeamMembers] = useState([]);

	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع الاحصائيات",
				breadcrumb: "الاحصائيات",
				button: {
					show: true,
					text: "اضافة احصائية جديدة",
					link: "/statistics/create",
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}pages/statistics/sections`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				// console.log(response.data.data[0].categories[0].posts[0].data.opinions);
				setTeamMembers([
					...response?.data?.data?.sections?.map(faq => {
						return {
							...faq,
							id: `${faq.slug}${v4()}`,
							slug: faq.slug,
							question: faq?.question,
							answer: faq?.answer,
						};
					}),
				]);
				setLoading(false);
			})
			.catch(function (error) {
				console.log(error);
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const columns = [
		// {
		// 	name: "id",
		// 	selector: "id",
		// 	sortable: true,
		// },
		{
			name: "العدد",
			sortable: true,
			selector: row => row?.count,
		},
		{
			name: "العنوان الرئيسي",
			sortable: true,
			selector: row => row?.sectionTitle?.ar,
		},
		{
			name: "العنوان الفرعى",
			sortable: true,
			selector: row => row?.sectionSubTitle?.ar,
		},
		{
			name: "الاجراءات",
			selector: "settings",
			cell: row => (
				<ul className="d-flex list-inline align-items-center m-0 gap-1">
					<li className="list-inline-item ">
						<Link
							className="bt bt-sm bt-success"
							to={`/statistics/show/${row.slug}`}
						>
							<i className="fas fa-edit"></i>
						</Link>
					</li>
					<li className="list-inline-item">
						<button
							className="bt bt-sm bt-danger"
							onClick={() => handleConfrimDelete(row.slug)}
						>
							<i className="fas fa-trash"></i>
						</button>
					</li>
				</ul>
			),
		},
	];

	const handleConfrimDelete = teamMemberSlug => {
		confirmAlert({
			title: "تأكيد الحذف",
			message: "هل أنت متأكد من رغبتك في الحذف؟",
			buttons: [
				{
					label: "نعم",
					onClick: () => deleteArticle(teamMemberSlug),
				},
				{
					label: "لا",
					onClick: () => console.log("No"),
				},
			],
		});
	};

	const deleteArticle = teamMemberSlug => {
		axios
			.delete(
				`${process.env.REACT_APP_API_URL}/pages/statistics/sections/${teamMemberSlug}`,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(_ => onStart() && toast.success("تم الحذف بنجاح"))
			.catch(_ => toast.error("حدث خطا!"));
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="datatable">
				<DataTableExtensions columns={columns} data={teamMembers}>
					<DataTable
						noHeader
						defaultSortField="id"
						defaultSortAsc={false}
						pagination
						highlightOnHover
						direction="rtl"
						striped
					/>
				</DataTableExtensions>
			</div>
		</section>
	);
};

export default StatisticsIndex;
